import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Textbox } from '../../models/editors/textbox.model';
import { Textarea } from '../../models/editors/textarea.model';
import { Switch } from '../../models/editors/switch.model';
import { Contained } from '../../models/editors/contained.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { FormControlService } from '../../shared/services/form-control.service';
import { ApiService } from '../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/services/alert.service';
import { Article } from '../../models/articles/articles.model';
import { Tags } from '../../models/editors/tags.model';
import { ContainedMany } from '../../models/editors/contained-many.model';
import { FormDetailBase } from '../../shared/components/base/form-detail/form-detail.base.component';
@Component({
  selector: 'swb-article-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService],
  encapsulation: ViewEncapsulation.None
})
export class ArticleDetailComponent extends FormDetailBase<Article> implements OnInit {
  private _availableCategories: any;

  public url = 'articles';
  protected _redirect = './articles';

  public entity = new Article({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název článku',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Obsah článku',
        validators: [atLeastOneLang],
        isMultilang: true,
        wysiwyg: 'article-detail'
      }),
      new Switch({
        key: 'custom_seo_data',
        label: 'Vlastní metadata',
        isMultilang: true,
        labelFalse: 'Vygenerovaná metadata'
      }),
      new Textbox({
        key: 'seo_title',
        label: 'Titulek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Textarea({
        key: 'seo_description',
        label: 'Popisek',
        validators: [],
        isMultilang: true,
        boundTo: 'custom_seo_data'
      }),
      new Tags({
        key: 'categories',
        label: 'Kategorie blogu',
        entities: this._availableCategories
      }),
      new ContainedMany({
        key: 'files',
        label: 'Galerie',
        imgOnly: false,
        upload: true,
        apiUrl: 'files'
      }),
      new Contained({
        key: 'form_id',
        label: 'Formulář',
        entity: this.entity.form,
        upload: false,
        apiUrl: 'forms'
      })
    ];
  }

  public formEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    this._getCategories('categories/list');

  }

  private _getCategories(uri: string) {
    this._apiService.get(uri)
      .subscribe(
        (response: any) => {
          this._availableCategories = { ...response }.data;

          this._getEntity();

        },
        (error) => console.error(error)
      );
  }

}
